import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SelectButton from "primevue/selectbutton";
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'USelectButton',
    props: {
        defaultActive: {
            type: Number,
            default: 1
        },
        options: {
            type: Array,
            default: () => ["One", "Two"]
        },
        multiple: {
            type: Boolean,
            default: false
        },
        fluid: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: ""
        }
    },
    emits: ["change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const value = props.multiple ? [] : ref(props.options[props.defaultActive - 1]);
        const emit = __emit;
        const handleChange = (event) => {
            if (event?.value) {
                emit("change", event?.value);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(SelectButton), {
                modelValue: _unref(value),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(value) ? (value).value = $event : null)),
                options: __props.options,
                multiple: __props.multiple,
                size: __props.size,
                fluid: __props.fluid,
                onChange: handleChange
            }, null, 8, ["modelValue", "options", "multiple", "size", "fluid"]));
        };
    }
});
